import { useContext } from 'react';
import { Route, Redirect, useLocation, RouteProps } from 'react-router-dom';
import { ApplicationProvider, appUserContext, authContext } from 'helpers/services';
import { Layout, CircleLoader } from 'components';


interface IProps extends RouteProps {
}

let PrivateRoute = ({ exact, path, component }: IProps) => {
    let location = useLocation();
    let authService = useContext(authContext);
    let userService = useContext(appUserContext);

    return (
        <>
            {authService.isLoading === true && <CircleLoader />}
            {authService.isLoading === false &&
                <>
                    {authService.isAuthenticated === false && <Redirect to={`/account/login?returnUrl=${location.pathname}`} />}
                    {authService.isAuthenticated === true &&
                        <>
                            {userService.isLoading === true && <CircleLoader />}
                            {userService.isLoading === false &&
                                <ApplicationProvider>
                                    <Layout layoutType='private'>
                                        <Route exact={exact} path={path} component={component} />
                                    </Layout>
                                </ApplicationProvider>
                            }
                        </>
                    }
                </>
            }
        </>
    )
}

export default PrivateRoute;